var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgW1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_3",
    "data-name": "Group 3",
    xmlns: "http://www.w3.org/2000/svg",
    width: 80,
    height: 69.8,
    viewBox: "0 0 80 69.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_83180",
    "data-name": "Path 83180",
    d: "M11.288,43.992H8.821l-1.48-5.547c-.141-.648-.282-1.441-.282-1.441H6.988a7.638,7.638,0,0,1-.282,1.441l-1.48,5.547H2.83L.081,34.268h2.4l1.339,5.907c.141.72.211,1.585.211,1.585a15.47,15.47,0,0,1,.352-1.585l1.551-5.907H8.116l1.551,5.907c.141.72.352,1.585.352,1.585s.07-.864.211-1.585l1.339-5.907h2.467Z",
    transform: "translate(0.06 25.591)",
    fillRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Path_83181",
    "data-name": "Path 83181",
    d: "M13.921,39.372c-1.762.072-3.313.216-3.313,1.729,0,.936.7,1.441,1.974,1.441a3.248,3.248,0,0,0,1.339-.216Zm-1.269,4.9c-2.819,0-4.3-1.153-4.3-3.1,0-2.665,2.678-3.169,5.568-3.313v-.5c0-1.008-.7-1.369-1.762-1.369a7.718,7.718,0,0,0-2.678.576l-.634-1.657a9.255,9.255,0,0,1,3.524-.72c2.4,0,3.806.936,3.806,3.458v5.979A10.307,10.307,0,0,1,12.652,44.27Z",
    transform: "translate(6.238 25.53)",
    fillRule: "evenodd"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Path_83182",
    "data-name": "Path 83182",
    d: "M13.881,45.871h2.4V31.753h-2.4Z",
    transform: "translate(10.366 23.713)",
    fillRule: "evenodd"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    id: "Path_83183",
    "data-name": "Path 83183",
    d: "M16.382,45.871h2.4V31.753h-2.4Z",
    transform: "translate(12.234 23.713)",
    fillRule: "evenodd"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    id: "Path_83184",
    "data-name": "Path 83184",
    d: "M23,35.914c-1.269,0-2.114.936-2.185,2.737l3.947-.576C24.834,36.635,24.13,35.914,23,35.914Zm4.088,3.458-6.132.864a2.338,2.338,0,0,0,2.608,2.089,5.824,5.824,0,0,0,2.608-.576l.7,1.8a7.844,7.844,0,0,1-3.524.72c-3.1,0-4.793-2.089-4.793-5.042s1.621-5.042,4.37-5.042c2.608,0,4.088,1.729,4.088,4.394A1.011,1.011,0,0,1,27.09,39.372Z",
    transform: "translate(13.862 25.53)",
    fillRule: "evenodd"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    id: "Path_83185",
    "data-name": "Path 83185",
    d: "M27.764,45.338c-1.833,0-2.678-1.008-2.678-3.025v-4.97h-1.2v-1.8h1.2V33.38l2.326-.72v2.881h1.762v1.8H27.412V42.1a.972.972,0,0,0,1.057,1.08,2.452,2.452,0,0,0,.7-.144v2.017A2.977,2.977,0,0,1,27.764,45.338Z",
    transform: "translate(17.839 24.39)",
    fillRule: "evenodd"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    id: "Path_83186",
    "data-name": "Path 83186",
    d: "M34.119,36.058c-1.269,0-1.9,1.153-1.9,3.1s.634,3.1,1.9,3.1,1.9-1.153,1.9-3.1S35.388,36.058,34.119,36.058Zm0,8.212c-2.749,0-4.3-2.161-4.3-5.042s1.551-5.042,4.3-5.042,4.3,2.161,4.3,5.042C38.418,42.037,36.868,44.27,34.119,44.27Z",
    transform: "translate(22.269 25.53)",
    fill: "#ff6400",
    fillRule: "evenodd"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    id: "Path_83187",
    "data-name": "Path 83187",
    d: "M41.087,44.085V37.674A1.5,1.5,0,0,0,39.4,36.089a5.848,5.848,0,0,0-1.41.216v7.707h-2.4V34.865a9.221,9.221,0,0,1,3.806-.72c2.819,0,4.088,1.153,4.088,3.242v6.627h-2.4Z",
    transform: "translate(26.578 25.499)",
    fill: "#ff6400",
    fillRule: "evenodd"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    id: "Path_83188",
    "data-name": "Path 83188",
    d: "M45.286,35.914c-1.269,0-2.114.936-2.185,2.737l3.947-.576C47.118,36.635,46.413,35.914,45.286,35.914Zm4.159,3.458-6.132.864a2.338,2.338,0,0,0,2.608,2.089,5.609,5.609,0,0,0,2.608-.576l.7,1.8a7.845,7.845,0,0,1-3.524.72c-3.1,0-4.793-2.089-4.793-5.042s1.621-5.042,4.37-5.042c2.608,0,4.088,1.729,4.088,4.394A2.762,2.762,0,0,1,49.444,39.372Z",
    transform: "translate(30.556 25.53)",
    fill: "#ff6400",
    fillRule: "evenodd"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    id: "Path_83189",
    "data-name": "Path 83189",
    d: "M64.282,15.991a6.252,6.252,0,0,0-8.952.288L46.1,25.716V6.7c0-3.674-2.749-6.7-6.132-6.7a5.777,5.777,0,0,0-3.806,1.513L35.1,2.377,12.194,25.788V6.7c0-3.674-2.749-6.7-6.132-6.7C2.749,0,0,3.025,0,6.7V40.122a7.457,7.457,0,0,0,1.057,3.746,3.706,3.706,0,0,0,.916,1.224,6.066,6.066,0,0,0,2.608,1.513,6.521,6.521,0,0,0,6.273-1.8L33.833,21.322v18.8a7.388,7.388,0,0,0,.564,2.809,5.288,5.288,0,0,0,1.339,2.161,6.252,6.252,0,0,0,8.952-.288L63.93,25.14C66.467,22.546,66.608,18.368,64.282,15.991Z",
    fillRule: "evenodd"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    id: "Path_83190",
    "data-name": "Path 83190",
    d: "M56.111,6.554a6.249,6.249,0,0,0-1.692-4.61A5.822,5.822,0,0,0,49.7.215a6.561,6.561,0,0,0-2.044.5,7.481,7.481,0,0,0-2.185,1.513L33.133,14.91a6.588,6.588,0,0,0-.282,9.148A6.252,6.252,0,0,0,41.8,23.77l2.114-2.161v18.8c0,3.674,2.749,6.7,6.132,6.7s6.132-3.025,6.132-6.7V6.914A.661.661,0,0,1,56.111,6.554Z",
    transform: "translate(23.254 0.145)",
    fill: "#ff6400",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgW1);
export default __webpack_public_path__ + "static/media/w1.f412ec6f3fd3d71b7a75c7c76c25b036.svg";
export { ForwardRef as ReactComponent };